<script setup lang="ts">
  /**
   * Button group — 03-components/06-buttons · OSCloud DS 1.1.47
   */
</script>

<template>
  <div class="button-group">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  /* Layout only — it never restyles the buttons in it. One pressed button at a
     time and disabling a value that is not currently allowed are the
     consumer's job. */
  .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bf-sp-2);
  }
</style>
